import { PostfixFunctionSchema } from 'api/apiTypes/postfixLogic';
import { z } from 'zod';

export const SourceOptionSchema = z.preprocess(
  (data) => {
    // if (typeof data === 'object' && data) {
    //   let source = null;
    //   if ('option' in data) {
    //     source = data.option;
    //     if (typeof data.option === 'string') {
    //       // option is the enum
    //       if ('source' in data && typeof data.source !== 'string') {
    //         return {
    //           ...data,
    //           source,
    //           option: source,
    //           value: data.source,
    //         };
    //       }
    //     }
    //   }
    //   if ('source' in data) {
    //     source = data.source;
    //   }
    //   return {
    //     ...data,
    //     source,
    //     option: source,
    //   };
    // }
    return data;
  },
  z.object({
    option: z.enum(['cookie', 'localStorage', 'sessionStorage', 'jsVariable', 'customFunction', 'endpoint']).optional(),
    source: z.union([PostfixFunctionSchema, z.string()]).optional(),
  })
);

export type SourceOption = z.infer<typeof SourceOptionSchema>;

export const ApiPrivacyConsentConfigurationGeolocationSchema = z.object({
  country: SourceOptionSchema.optional(),
  state: SourceOptionSchema.optional(),
});

export type ApiPrivacyConsentConfigurationGeolocation = z.infer<typeof ApiPrivacyConsentConfigurationGeolocationSchema>;
